// extracted by mini-css-extract-plugin
export default {"featureContainer":"feature_featureContainer__xrQzt","imageContainer":"feature_imageContainer__eQozQ"};